<template>
  <div class="setup-eula">
    <EULA :contentOwnership="contentOwnership" />
  </div>
</template>

<script>
import EULA from './content-fields/EULA';

export default {
  name: 'SetupEULA',
  components: {
    EULA,
  },
  props: {
    contentOwnership: {
      type: Object,
      required: true,
    },
  },
};
</script>
